import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import ProxiesTabs1 from 'src/pages/admin/proxyTab1/Tab1';
import ProxiesTabs2 from 'src/pages/admin/proxyTab1/Tab2';
import {
    checkImpersonationActive,
    checkProxyActive,
    logErrorToConsole,
} from 'src/utils/util';
import {
    HeaderTextContainer1,
    CloseIcon,
    Container,
    Container1,
    ProxyIconContainer,
    PlusContainer,
    StyledImage,
    ButtonLabel,
    ContainerGrid1Mob,
    HeaderTextContainer1Mob,
    ContainerGrid1,
    BackTitle,
    SubHeading,
    User,
    Designation,
    HeaderTextContainer2,
    Mobile,
    Desktop,
    PopupContainer,
    BackTitleMob,
} from './index.styled';
import AddProxy from '../addProxy';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import { proxiesTabs } from 'src/pages/admin/proxiesTab/adminTabConstants';
import AdminDetailTabListContainer from 'src/pages/admin/proxiesTab/adminDetailTabListContainer';
import Plus from 'src/assets/images/Add.svg';
import LeftArrow from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import {
    getProxyList,
    setAccountTabActiveId,
} from 'src/pages/admin/redux/action';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const ProxyTab1 = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [showAddProxy, setshowAddProxy] = useState(false);
    const [addProxy] = useState(false);
    const [addProxyData, setAddProxyData] = useState({});

    const openAddProxy = (addProxyData) => {
        setAddProxyData(addProxyData);
        setshowAddProxy(true);
    };

    const closeAddProxy = () => {
        setAddProxyData({});
        setshowAddProxy(false);
    };
    const onTabSwitchHandler = (Id) => {
        dispatch(setAccountTabActiveId(Id));
    };
    useEffectWithErrorLogging(() => {
        dispatch(getProxyList(proxyTabData && proxyTabData.networkIdName));
    }, []);

    const addProxyStatus = useSelector(
        (state) => state.AdminProxyReducer.addProxyStatus
    );
    const accountTabActiveId = useSelector(
        (state) => state.AdminReducer.accountTabActiveId
    );

    const updateProxyStatus = useSelector(
        (state) => state.AdminProxyReducer.updateProxyStatus
    );

    const statusCode = useSelector(
        (state) => state.AdminProxyReducer.statusCode
    );
    const proxyTabData = useSelector(
        (state) => state.AdminReducer.proxyTabData
    );

    useEffectWithErrorLogging(() => {
        if (updateProxyStatus === '11614') {
            dispatch(getProxyList(proxyTabData && proxyTabData.networkIdName));
        }
    }, [updateProxyStatus]);

    useEffectWithErrorLogging(() => {
        if (addProxyStatus === '10763') {
            setshowAddProxy(false);
            dispatch(getProxyList(proxyTabData && proxyTabData.networkIdName));
        }
    }, [addProxyStatus]);

    useEffectWithErrorLogging(() => {
        if (statusCode === '200') {
            dispatch(getProxyList(proxyTabData && proxyTabData.networkIdName));
        }
    }, [statusCode]); 
    return (
        <>
            <Container1
                container
                justifyContent={'space-between'}
                direction="row"
                align-item="center"
            >
                <ContainerGrid1
                    item
                    xs={11}
                    sm={11}
                    md={11}
                    lg={11}
                    xl={11}
                // mobile={6}
                >
                    <BackTitle
                       id="back-to-user-details"
                        // onClick={props.handleClose}

                        onClick={() => {
                            try {
                                props.handleClose(true);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        <img src={LeftArrow} alt="back"></img>
                        {t('admin.userProxies.backToUserDetails')}
                    </BackTitle>
                </ContainerGrid1>
                <ContainerGrid1
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={6}
                >
                    {/* <CloseIcon
                        mobilePath={Close}
                        onClick={props.handleClose}
                        show={true}
                    /> */}
                </ContainerGrid1>
            </Container1>
            <HeaderTextContainer1>
                {t('admin.userProxies.proxiesFor')}{' '}
                <span className="admin-person-name-dt-mask">{proxyTabData && proxyTabData.firstName}</span>{' '}
                <span className="admin-person-name-dt-mask">{proxyTabData && proxyTabData.lastName}</span>
            </HeaderTextContainer1>

            <ContainerGrid1Mob
                container
                justifyContent={'space-between'}
                direction="row"
                align-item="center"
            >
                <ContainerGrid1Mob
                    item
                    xs={11}
                    sm={11}
                    md={11}
                    lg={11}
                    xl={11}
                    mobile={6}
                >
                    <BackTitleMob
                        id="back-to-user-details-mob"
                        onClick={() => {
                            try {
                                props.handleClose(true);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        <img src={LeftArrow} alt="back"></img>
                        {t('admin.userProxies.backToUserDetails')}
                    </BackTitleMob>
                </ContainerGrid1Mob>
                <ContainerGrid1Mob
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={6}
                >
                    {/* <CloseIcon
                        mobilePath={Close}
                        onClick={props.handleClose}
                        show={true}
                    /> */}
                </ContainerGrid1Mob>
                <ContainerGrid1Mob
                    item
                    xs={11}
                    sm={11}
                    md={11}
                    lg={11}
                    xl={11}
                    mobile={6}
                >
                    <HeaderTextContainer1Mob>
                        {t('admin.userProxies.proxiesFor')}{' '}
                        <span className="admin-person-name-dt-mask">{proxyTabData && proxyTabData.firstName}</span>{' '}
                        <span className="admin-person-name-dt-mask">{proxyTabData && proxyTabData.lastName}</span>
                    </HeaderTextContainer1Mob>
                </ContainerGrid1Mob>
            </ContainerGrid1Mob>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <SubHeading
                    item
                    xs={6}
                    sm={6}
                    md={12}
                    lg={12}
                    xl={12}
                    mobile={6}
                >
                    <User>{proxyTabData && proxyTabData.networkIdName}</User>
                    <Designation>
                        {proxyTabData && proxyTabData.userRoles}
                    </Designation>
                </SubHeading>
                <Mobile>
                    <ProxyIconContainer
                        backGroundColor={
                            checkProxyActive() || checkImpersonationActive()
                                ? '#9f9f9f'
                                : '#e50b7e'
                        }
                    >
                        <PlusContainer>
                            <a
                                id="add-proxy-btn"
                                style={{ display: 'flex' }}
                                onClick={() =>
                                    !checkProxyActive() &&
                                    !checkImpersonationActive() && openAddProxy(proxyTabData && proxyTabData)
                                }
                            >
                                <StyledImage
                                    src={Plus}
                                    width="auto"
                                    height="auto"
                                    alt="+"
                                    cursor={
                                        !checkProxyActive() &&
                                            !checkImpersonationActive()
                                            ? 'pointer'
                                            : 'default'
                                    }
                                />
                                <ButtonLabel cursor={
                                    !checkProxyActive() &&
                                        !checkImpersonationActive()
                                        ? 'pointer'
                                        : 'default'
                                }>
                                    {t('admin.userProxies.proxy')}
                                </ButtonLabel>
                            </a>
                        </PlusContainer>
                    </ProxyIconContainer>
                </Mobile>
            </div>
            <Container>
                <AdminDetailTabListContainer
                    accountDetailTabList={proxiesTabs()}
                    tabActiveId={accountTabActiveId}
                    tabSwitch={onTabSwitchHandler}
                />
                <Desktop>
                    <ProxyIconContainer backGroundColor={
                        checkProxyActive() || checkImpersonationActive()
                            ? '#9f9f9f'
                            : '#e50b7e'
                    }>
                        <PlusContainer>
                            <a
                                id="add-proxy-btn"
                                style={{ display: 'flex' }}
                                onClick={() =>
                                    !checkProxyActive() &&
                                    !checkImpersonationActive() &&
                                    openAddProxy(proxyTabData && proxyTabData)
                                }
                            >
                                <StyledImage
                                    src={Plus}
                                    width="auto"
                                    height="auto"
                                    alt="+"
                                    cursor={
                                        !checkProxyActive() &&
                                            !checkImpersonationActive()
                                            ? 'pointer'
                                            : 'default'
                                    }
                                />
                                <ButtonLabel cursor={
                                    !checkProxyActive() &&
                                        !checkImpersonationActive()
                                        ? 'pointer'
                                        : 'default'
                                }>
                                    {t('admin.userProxies.proxy')}
                                </ButtonLabel>
                            </a>
                        </PlusContainer>
                    </ProxyIconContainer>
                </Desktop>
            </Container>
            <HeaderTextContainer2
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                mobile={6}
                key="role"
            >
                {accountTabActiveId === 'proxiesTab1' && <ProxiesTabs1 />}
            </HeaderTextContainer2>

            <HeaderTextContainer2
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                mobile={6}
                key="role"
            >
                {accountTabActiveId === 'proxiesTab2' && <ProxiesTabs2 />}
            </HeaderTextContainer2>
            {showAddProxy && (
                <Popup id={'admin-proxyTab1-index-popup'} contentWidth={'50%'} margin={'15px'}>
                    <PopupContainer>
                        <AddProxy
                            addProxyPopup={addProxy}
                            handleClose={closeAddProxy}
                            isFromAccount={props.isFromAccount}
                            addProxyData={addProxyData}
                        />
                    </PopupContainer>
                </Popup>
            )}
        </>
    );
};
export default ProxyTab1;
